(() => {
  if (customElements.get('paphos-people-album')) return;

  class PaphosPeopleAlbum extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-ppa-photo]');
        if (link && this.contains(link)) {
          // Preserve ordinary open-in-new-tab behavior and the no-script link fallback.
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.trigger = link;
          this.querySelector('[data-ppa-title]').textContent = link.dataset.title;
          const image = this.querySelector('[data-ppa-full]');
          image.src = link.href;
          image.alt = `תמונת המחשה — ${link.dataset.title}`;
          this.dialog.showModal();
          this.querySelector('[data-ppa-close]').focus();
        }
        if (event.target.closest('[data-ppa-close]')) this.dialog.close();
        if (event.target === this.dialog) {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right ||
              event.clientY < bounds.top || event.clientY > bounds.bottom) {
            this.dialog.close();
          }
        }
      }, options);

      this.dialog.addEventListener('close', () => {
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      }, options);
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
    }
  }

  customElements.define('paphos-people-album', PaphosPeopleAlbum);
})();
